import {IconButtonV5} from "../../ui/5.0/interaction/IconButtonV5";
import {Functions} from "../../utils/function/Functions";
import GlobeIcon from "../../ui/5.0/icons/globe.svg?react";
import UsersIcon from "../../ui/5.0/icons/users.svg?react";
import UserIcon from "../../ui/5.0/icons/user.svg?react";
import type {AppState} from "../state/AppState";
import type {Report} from "./Report";

export const getReportIcon = (report: Report, appState: AppState) => {
	if (report.isGlobal) {
		return (
			<IconButtonV5
				IconComponent={GlobeIcon}
				title="Global Report"
				className="reportIcon globalView button"
				onClick={Functions.emptyFunction}
				noPointer={true}
				noHover={true}
			/>
		);
	} else if (report.ownedBy != appState.user?.id) {
		return (
			<IconButtonV5
				IconComponent={UsersIcon}
				title="Shared Report"
				className="reportIcon sharedReport button"
				onClick={Functions.emptyFunction}
				noPointer={true}
				noHover={true}
			/>
		);
	} else {
		return (
			<IconButtonV5
				IconComponent={UserIcon}
				title="My Report"
				className="reportIcon myReport button"
				onClick={Functions.emptyFunction}
				noPointer={true}
				noHover={true}
			/>
		);
	}
};
